"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";

import "./MobileProcessSection.scss";

const MobileProcessSection = ({ process }) => {
  if (!process) return null;

  const { title, description, processItems = [] } = process;

  const [activeCard, setActiveCard] = useState(processItems[0]);

  return (
    <section className="product-process-section">
      <div className="container">
        <div className="process-top-layout">
          <div className="process-right-content">
            <h2>{title}</h2>
            <p>{description}</p>
          </div>

          <div className="process-left-grid">
            {processItems.map((item) => (
              <motion.div
                key={item.id}
                className={`process-card ${
                  activeCard?.id === item.id ? "active" : ""
                }`}
                onClick={() => setActiveCard(item)}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.3 }}
              >
                <div className="icon-box">
                  <Image
                    src={item.icon}
                    alt={item.title}
                    width={70}
                    height={70}
                  />
                </div>

                <div className="card-content">
                  <div className="card-title">{item.title}</div>
                  <p>{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* <motion.div
          className="process-image-preview"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={activeCard?.id}
              className="preview-image-wrapper"
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Image
                src={activeCard?.image}
                alt={activeCard?.title}
                fill
                className="preview-image"
              />
            </motion.div>
          </AnimatePresence>
        </motion.div> */}
      </div>
    </section>
  );
};

export default MobileProcessSection;